import React, { useContext, useEffect, useState } from "react"
import { NavLink, Redirect } from "react-router-dom"

import Constants from "../../config.js"
import { getLog } from "../../helpers/helpers"
import { UserContext } from "../../Contexts/UserContext/UserContext"
import { ButtonPrimary, ButtonPrimaryOutlined } from "../../components/Buttons.js"



export default function EnterWalletName(props) {
    const userContext = useContext(UserContext)
    const classname = "EnterWalletName: "

    const function_id = classname + "render(): "
    const log = getLog(function_id)

    const [walletname, set_walletname] = useState("")

    // Flow enforcement: if there's no pending_wallet with a mnemonic, the
    // user got here without completing step 1 (seed generation/entry).
    // Redirect to /select_wallet to restart the flow.
    if (!userContext.pending_wallet || !userContext.pending_wallet.mnemonic) {
        return <Redirect to="/select_wallet" push />
    }

    // Initialize walletname from pending_wallet on mount. If no walletname
    // is set yet, default to "unnamed wallet" immediately so that the next
    // step's flow enforcement (wallet_password checks pending_wallet.walletname)
    // always sees a non-empty value — even if the user clicks Continue
    // without typing anything.
    useEffect(() => {
        const pending = userContext.pending_wallet
        if (pending) {
            if (pending.walletname && pending.walletname !== "unnamed wallet") {
                set_walletname(pending.walletname)
            } else {
                // Initialize pending_wallet.walletname to "unnamed wallet"
                // right away so it's never empty.
                userContext.set_pending_wallet({
                    ...pending,
                    walletname: "unnamed wallet",
                })
            }
        }
    }, [])

    const onChange_walletname = (event) => {
        const new_name = event.target.value
        set_walletname(new_name)
        // Store the wallet name in pending_wallet. If the field is empty,
        // default to "unnamed wallet" so the next step's flow enforcement
        // (wallet_password checks pending_wallet.walletname) always sees
        // a non-empty value.
        userContext.set_pending_wallet({
            ...userContext.pending_wallet,
            walletname: new_name.trim().length > 0 ? new_name : "unnamed wallet",
        })
    }

    var returnbuttonjsx = ""
    var previous_mode = userContext.get_newpassword_previous()
    if (previous_mode == "restore_from_seed") {
        returnbuttonjsx =
            <NavLink className="return-logo" to="/restore_wallet">
                <ButtonPrimaryOutlined>
                    Back
                </ButtonPrimaryOutlined>
            </NavLink>
    } else {  // if (previous_mode == "create_new_wallet") {
        returnbuttonjsx =
            <NavLink className="return-logo" to="/create_new_wallet">
                <ButtonPrimaryOutlined>
                    Back
                </ButtonPrimaryOutlined>
            </NavLink>
    }

    return (
        <div className="mode-selection-style">

            <h2>
                <br />
                Give a name to your wallet
            </h2>
            <br /><br />

            <form name="message" method="post">
                <section>
                    <div className="input_style" >
                        <div className="field_name">
                            <input onChange={onChange_walletname}
                                value={walletname}
                                id="walletname" type="text" name="wallet_name"
                                className="text_spacing"
                                placeholder={Constants.ENTER_WALLET_NAME}
                                style={{ padding: "0.5em", width: "100%", maxWidth: "20em" }} />
                        </div>
                        <br />
                    </div>
                </section>
            </form>
            <div style={{ height: "20vh" }}>&nbsp;</div>

            {/* Buttons */}

            <div className="bottom-buttons">
                <div className="return-button">
                    {returnbuttonjsx}
                </div>
                <div className="next-button">
                    <NavLink className="return-logo" to="/wallet_password">
                        <ButtonPrimary>
                            Continue
                        </ButtonPrimary>
                    </NavLink>
                </div>
            </div>

            {/* make it easier to scroll if needed */}
            <div style={{ height: "40vh" }}>&nbsp;</div>

        </div>
    )
}
